/* eslint-disable react/prop-types */
import React from 'react';
import ReactSelect from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import NoSsr from '@material-ui/core/NoSsr';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  const {
    selectProps,
    innerRef,
    children,
    innerProps,
  } = props;

  return (
    <TextField
      fullWidth
      variant="outlined"
      InputProps={{
        inputComponent,
        inputProps: {
          className: selectProps.classes.input,
          inputRef: innerRef,
          children,
          ...innerProps,
        },
      }}
      {...selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  const {
    innerRef,
    isFocused,
    isSelected,
    innerProps,
    children,
    theme,
  } = props;

  const outerStyle = {};
  const innerStyle = {};
  if (isSelected) {
    outerStyle.borderLeft = `0.35rem solid ${theme.colors.primary}`;
    outerStyle.backgroundColor = '#f7f7f7';
  } else {
    innerStyle.paddingLeft = '0.35rem';
  }

  return (
    <MenuItem
      buttonRef={innerRef}
      selected={isFocused}
      component="div"
      {...innerProps}
      style={outerStyle}
    >
      <div
        style={innerStyle}
      >
        {children}
      </div>
    </MenuItem>
  );
}

function ValueContainer(props) {
  const {
    selectProps,
    children,
  } = props;

  return <div className={selectProps.classes.valueContainer}>{children}</div>;
}

function Menu(props) {
  const {
    selectProps,
    innerProps,
    children,
  } = props;

  return (
    <Paper className={selectProps.classes.paper} {...innerProps}>
      {children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  Option,
  ValueContainer,
  DropdownIndicator: () => null,
  IndicatorSeparator: () => null,
};

const Select = ({
  theme, classes, noOptionsMessage, placeholder, loadingMessage, ...other
}) => {
  const selectStyles = {
    input: base => ({
      ...base,
      color: theme.palette.text.primary,
      '& input': {
        font: 'inherit',
      },
    }),
  };
  return (
    <NoSsr>
      <ReactSelect
        classes={classes}
        components={components}
        styles={selectStyles}
        noOptionsMessage={noOptionsMessage}
        loadingMessage={loadingMessage}
        placeholder={placeholder}
        theme={_theme => ({
          ..._theme,
          colors: {
            ...theme.colors,
            primary: theme.palette.primary.main,
            secondary: theme.palette.secondary.main,
          },
        })}
        {... other}

      />
    </NoSsr>
  );
};

Select.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  noOptionsMessage: PropTypes.func,
  placeholder: PropTypes.string,
  loadingMessage: PropTypes.func,
};

Select.defaultProps = {
  noOptionsMessage: () => 'Ingen treff',
  loadingMessage: () => 'Laster...',
  placeholder: '',
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 250,
  },
  input: {
    display: 'flex',
    // padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    color: '#444',
  },
  chip: {
    margin: `${theme.spacing(0.5)}px ${theme.spacing(0.25)}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(1)}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  },
});

export default withStyles(styles, { withTheme: true })(Select);
